module.exports = __webpack_public_path__ + "img/logo_pudinxchain.b4b246dd.png";